import { render } from "./ChatDemo.vue?vue&type=template&id=2321500a&scoped=true"
import script from "./ChatDemo.vue?vue&type=script&lang=js"
export * from "./ChatDemo.vue?vue&type=script&lang=js"

import "./ChatDemo.vue?vue&type=style&index=0&id=2321500a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2321500a"]])

export default __exports__